import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { User } from 'src/app/core/objects/user';
import { PaymentApiService } from 'src/app/core/services/payment-api.service';
import { UserService } from 'src/app/core/services/user.service';
import { ModalService } from 'src/app/modal/modal.service';
import { ProInfoComponent } from '../../modal/components/pro-info/pro-info.component';

@Directive({
    selector: '[glPremium]',
    standalone: false
})
export class PremiumCoverDirective implements AfterViewInit, OnDestroy {
  @Input() private glPremium = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private elRef: ElementRef<HTMLElement>,
    private modalService: ModalService,
    private userService: UserService,
    private paymentApiService: PaymentApiService,
  ) {}

  public ngAfterViewInit(): void {
    this.subscriptions.push(
      this.userService.user.subscribe((user: User) => {
        if (this.glPremium && !_.isEmpty(user) && !user.isPremium) {
          this.generatePremiumCover();
        } else {
          this.deletePremiumCover();
        }
      }),
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  public deletePremiumCover(): void {
    const refElement = this.elRef.nativeElement;
    refElement.style.removeProperty('opacity');
    if (refElement.querySelector('#overflowPremium')) {
      refElement.querySelector('#overflowPremium').remove();
    }
  }

  public generatePremiumCover(): void {
    const refElement = this.elRef.nativeElement;
    refElement.style.opacity = '0.5';
    refElement.style.position = 'relative';
    refElement.style.pointerEvents = 'auto';

    const node = document.createElement('div');
    node.id = 'overflowPremium';
    node.style.position = 'absolute';
    node.style.top = '0';
    node.style.bottom = '0';
    node.style.left = '0';
    node.style.right = '0';
    node.onclick = (e) => {
      e.stopPropagation();
      e.preventDefault();
      this.paymentApiService
        .getPayment(this.userService.getState()?.company?.country)
        .subscribe(() => this.modalService.open(ProInfoComponent).subscribe());
    };

    refElement.appendChild(node);
  }
}
